module.exports = __webpack_public_path__ + "img/upgrade2.c1f4ec1b.png";